import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import css from "./AdminPage.module.css";
import { Head } from "../../utils/Head";
import { Input } from "../../components/common/Input";
import { UserContext } from "../../context/UserContext";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import { InputArea } from "../../components/common/InputArea";

export const MeetingNew = () => {
  const { userData } = useContext(UserContext);
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [schedule, setSchedule] = useState("");
  const [participants, setParticipants] = useState([]);
  const [participantInput, setParticipantInput] = useState("");
  const [meetingType, setMeetingType] = useState("consultation");
  const [meetingUrl, setMeetingUrl] = useState("");
  const [loading, setLoading] = useState(false);

  function handleTagKeyDown(e) {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();

      let email = participantInput.trim().replace(",", "");

      if (!email) return;

      // Evita duplicados
      if (participants.includes(email)) {
        setParticipantInput("");
        return;
      }

      setParticipants([...participants, email]);
      setParticipantInput("");
    }
  }

  const generateRoomName = () =>
    `ibhava-${Math.random().toString(36).substring(2, 10)}-${Date.now()}`;

  async function handleSubmit() {
    if (!title || !schedule) {
      alert("Por favor, preencha o título e a data/hora da reunião.");
      return;
    }

    setLoading(true);

    try {
      const id = crypto.randomUUID();
      const roomName = generateRoomName();

      const newMeeting = {
        id,
        createdAt: new Date().toISOString(),
        proId: userData.id,
        proName: userData.displayName,
        title,
        description,
        groupId: "",
        scheduleFor: schedule,
        jitsiRoomName: roomName,
        meetingUrl: meetingUrl,
        participants: participants,
        notes: "",
        status: "scheduled",
        type: meetingType,
        moderatorOnline: false,
      };

      // 🔹 grava no Firestore
      await setDoc(doc(db, "meetings", id), newMeeting);

      alert("Reunião criada com sucesso!");
      navigate("/admin");
    } catch (error) {
      console.error("Erro ao criar reunião:", error);
      alert("Ocorreu um erro ao criar a reunião.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={css.container}>
      <Head title="Nova Reunião" description="Criar nova reunião - Ibhava" />
      <h2 className={css.title}>Nova Reunião</h2>

      <p>Tipo: </p>
      <div>
        <label className={css.axis}>
          consultation
          <input
            type="checkbox"
            checked={meetingType === "consultation" ? true : false}
            onChange={() => {
              setMeetingType("consultation");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          health
          <input
            type="checkbox"
            checked={meetingType === "health" ? true : false}
            onChange={() => {
              setMeetingType("health");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
        <label className={css.axis}>
          supervision
          <input
            type="checkbox"
            checked={meetingType === "supervision" ? true : false}
            onChange={() => {
              setMeetingType("supervision");
            }}
          />
          <span className={css.checkmark}></span>
        </label>
      </div>

      <Input
        type="text"
        name="title"
        placeholder="Profissional"
        label="Profissional"
        value={userData.displayName}
        required
        className={css.inputText}
        onChange={(e) => setTitle(e.target.value)}
        autoComplete="off"
      />

      <Input
        type="text"
        name="title"
        placeholder="Título"
        label="Título"
        value={title}
        required
        className={css.inputText}
        onChange={(e) => setTitle(e.target.value)}
        autoComplete="off"
      />

      <Input
        type="text"
        name="url"
        placeholder="Url"
        label="Url"
        value={meetingUrl}
        required
        className={css.inputText}
        onChange={(e) => setMeetingUrl(e.target.value)}
        autoComplete="off"
      />

      <InputArea
        type="text"
        name="description"
        placeholder="description"
        label="description"
        value={description}
        required
        className={css.inputText}
        onChange={(e) => setDescription(e.target.value)}
        autoComplete="off"
      />

      <Input
        type="datetime-local"
        name="schedule"
        label="Data e hora"
        value={schedule}
        required
        className={css.inputText}
        onChange={(e) => setSchedule(e.target.value)}
      />

      <label className={css.inputText}>Participantes</label>

      <div className={css.tagsContainer}>
        {participants.map((email, index) => (
          <div key={index} className={css.tag}>
            {email}
            <span
              className={css.removeTag}
              onClick={() =>
                setParticipants(participants.filter((_, i) => i !== index))
              }
            >
              ×
            </span>
          </div>
        ))}

        <input
          type="text"
          className={css.tagsInput}
          placeholder="Digite um email e pressione Enter"
          value={participantInput}
          onChange={(e) => setParticipantInput(e.target.value)}
          onKeyDown={handleTagKeyDown}
        />
      </div>

      <div className={css.footer}>
        <button
          className="saveButton"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Salvando..." : "Salvar"}
        </button>
      </div>
    </div>
  );
};
